import { render } from "./RatingTD.vue?vue&type=template&id=6923bdc2"
import script from "./RatingTD.vue?vue&type=script&lang=js"
export * from "./RatingTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__